import { render, staticRenderFns } from "./InstanceForm.vue?vue&type=template&id=724596a6"
import script from "./InstanceForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstanceForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports